import React, { useLayoutEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { DrawerProps } from '@material-ui/core'
import { ExitToApp } from '@material-ui/icons'

import { useLogout } from 'providers/UserContextProvider'
import { useDrawerToggle } from 'providers/DrawerStateProvider'
import { useSignOutMutation } from 'api/mutations/authentication/authentication'
import { ACCOUNT_NAVIGATION_TAB } from 'constants/tabs'
import { useNavigationTabs } from 'hooks/useNavigationTabs'
import BellVRLogo from 'assets/images/logo.png'
import { NavigationList } from './NavigationList/NavigationList'
import { NavigationListItem } from './NavigationList/NavigationListItem/NavigationListItem'
import * as Styled from './NavigationDrawer.styles'

const NavigationDrawer: React.FC<DrawerProps> = (props) => {
  const { variant, open } = props
  const { t } = useTranslation()
  const listContainerRef = useRef<HTMLDivElement>(null)
  const logout = useLogout()
  const handleDrawerToggle = useDrawerToggle()
  const [accountTab] = useNavigationTabs([ACCOUNT_NAVIGATION_TAB])
  const { mutate: logoutMutate } = useSignOutMutation({
    onSettled: () => logout()
  })

  useLayoutEffect(() => {
    if (variant === 'temporary' && open && listContainerRef.current) {
      listContainerRef.current.scrollTop = 0
    }
  }, [variant, open])

  return (
    <Styled.Drawer {...props}>
      <Styled.Toolbar to='/'>
        <Styled.LogoImage src={BellVRLogo} alt='BellVR Logo' />
      </Styled.Toolbar>
      <Styled.ListContainer ref={listContainerRef}>
        <NavigationList />
      </Styled.ListContainer>
      <Styled.Footer>
        <NavigationListItem
          to={accountTab.to}
          selected={accountTab.selected}
          primary={t(accountTab.translationKey)}
          icon={accountTab.icon}
          onClick={handleDrawerToggle}
        />
        <Styled.NavigationListItem
          primary={t('common.signOut')}
          icon={<ExitToApp />}
          onClick={() => logoutMutate(undefined)}
        />
      </Styled.Footer>
    </Styled.Drawer>
  )
}

export { NavigationDrawer }
